<template>
  <div class="p-1">
    <div v-if="showError" class="w-100 text-center pt-4">
      <h2 class="mb-1">Page Not Found 🕵🏻‍♀️</h2>
      <p class="mb-2">
        Oops! 😖 The requested URL was not found on this server.
      </p>
      <b-img fluid :src="imgUrl" alt="Error page" />
    </div>
    <template v-else>
      <!-- kent -->
      <template v-if="db == '/r6Q0RYpjkcYn0rZGVa/OytKs xrVo3L'">
        <inquiry-other
          :db="$route.query.db"
          :cID="$route.query.cId"
          :school="school"
          :classes="classesOptions"
        />
      </template>
      <!-- veritas -->
      <template v-else-if="db == '/r6Q0RYpjkepcuY894yPgQ=='">
        <inquiry-veritas
          :db="$route.query.db"
          :cID="$route.query.cId"
          :school="school"
          :classes="classesOptions"
        />
      </template>
      <template v-else>
        <b-row align-h="center">
          <b-col class="text-center" md="7">
            <b-img
              v-if="school.logo == null || school.logo == ''"
              ref="previewEl"
              src="https://cdn.cloudious.net/file-1776666463641-10693955.png"
              fluid
              height="100px"
              width="100px"
            />
            <b-img
              v-else
              ref="previewEl"
              :src="school.logo"
              fluid
              style="max-width: 280px; max-height: 150px"
            />
            <div class="mt-1 details-adjust">
              <h3>{{ school.name }}</h3>
              <h5>
                <feather-icon icon="MapPinIcon" class="mr-50" />
                {{ school.address }}
              </h5>
              <h5>
                <feather-icon icon="PhoneIcon" class="mr-50" />
                {{ school.phone || school.mobile }}
              </h5>
            </div>
          </b-col>
        </b-row>
        <b-row align-h="center" class="mt-1">
          <b-col md="7">
            <b-card class="card">
              <h3 class="">Student Information</h3>
              <hr />
              <b-row align-h="center">
                <b-col md="4">
                  <b-form-group
                    class="text-center mb-50"
                    ref="picture"
                    label=" "
                    invalid-feedback="Picture is required."
                  >
                    <b-media
                      no-body
                      class="justify-content-center student-photo-upload"
                    >
                      <div
                        v-if="!profilePicturePreview && logoloading !== true"
                        class="student-photo-frame"
                      >
                        <b-link @click="$refs.fileProfile.click()">
                          <b-img
                            ref="previewEl"
                            src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
                            style="border-radius: 100px"
                            fluid
                            height="120px"
                            width="120px"
                          />
                        </b-link>
                      </div>

                      <div
                        v-else-if="
                          !profilePicturePreview && logoloading === true
                        "
                        class="student-photo-frame"
                      >
                        <b-spinner
                          variant="primary"
                          type="grow"
                          label="Spinning"
                        />
                      </div>

                      <div
                        v-else
                        class="student-photo-frame student-photo-frame--loaded"
                      >
                        <img
                          class="rcorners2 student-photo-img"
                          :src="profilePicturePreview"
                          alt="Student photo"
                          referrerpolicy="no-referrer"
                          @error="onPicturePreviewError"
                          @click="
                            logoloading !== true && $refs.fileProfile.click()
                          "
                        />
                        <div
                          v-if="logoloading === true"
                          class="student-photo-upload-overlay"
                        >
                          <b-spinner variant="primary" type="grow" />
                        </div>
                        <b-button
                          v-if="logoloading !== true"
                          class="student-photo-delete-btn"
                          variant="danger"
                          @click.stop="deleteLogo()"
                        >
                          <feather-icon icon="Trash2Icon" size="16" />
                        </b-button>
                      </div>

                      <input
                        type="file"
                        id="fileProfile"
                        hidden
                        ref="fileProfile"
                        @change="selectlogo()"
                        accept="image/*"
                      />
                    </b-media>

                    <h6 class="mb-0 mt-1" v-if="logoloading === true">
                      {{ $t("Uploading...") }}
                    </h6>
                    <h6 class="mb-0 mt-1" v-else-if="!profilePicturePreview">
                      Upload Photo
                    </h6>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr />

              <b-row>
                <template v-if="db == '/r6Q0RYpjkeTUi0oFvmLqQ=='">
                  <b-col md="6">
                    <b-form-group
                      label="Program *"
                      invalid-feedback="Program is required."
                      label-class="font-weight-bold"
                      ref="dep"
                    >
                      <v-select
                        v-model="depID"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="depList"
                        :clearable="false"
                        :reduce="(val) => val.id"
                        label="name"
                        :disabled="dataloading"
                        placeholder="Select program"
                        @input="setClasses"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Course *"
                      invalid-feedback="Course is required."
                      label-class="font-weight-bold"
                      ref="course"
                    >
                      <v-select
                        v-model="myObj.house"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="courseList"
                        :clearable="false"
                        :disabled="dataloading"
                        placeholder="Select course"
                      />
                    </b-form-group>
                  </b-col>
                </template>
                <b-col md="6">
                  <b-form-group
                    label="Name *"
                    invalid-feedback="Student name is required."
                    label-class="font-weight-bold"
                  >
                    <b-form-input
                      placeholder="Enter name"
                      ref="name"
                      v-model.trim="myObj.name"
                      @focusout="CheckName()"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    label="Father / Spouse Name *"
                    invalid-feedback="Name is required"
                    label-class="font-weight-bold"
                  >
                    <b-form-input
                      ref="fname"
                      placeholder="Enter father / spouse name."
                      v-model="myObj.father_name"
                      @focusout="CheckFName()"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    label="Gender *"
                    invalid-feedback="Gender is required"
                    label-class="font-weight-bold"
                    ref="gender"
                  >
                    <v-select
                      v-model="myObj.gender"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="genders"
                      :clearable="false"
                      placeholder="Select gender"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Date of Birth *"
                    invalid-feedback="Date of birth is required."
                    label-class="font-weight-bold"
                    ref="dob"
                  >
                    <flat-pickr
                      :config="config"
                      v-model="myObj.date_of_birth"
                      class="form-control"
                      placeholder="Select date of birth"
                      @on-change="formatDate"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- <b-row>
                <b-col md="6">
                  <b-form-group
                    label="Reg number"
                    invalid-feedback="Reg number"
                  >
                    <b-form-input
                      v-model="myObj.grNo"
                      class="form-control"
                      placeholder="Enter reg number"
                      @focusout="CheckGrNo()"
                      ref="grNo"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Family code"
                    invalid-feedback="Family code is required."
                  >
                    <b-form-input
                      type="number"
                      v-model="myObj.family_code"
                      class="form-control"
                      placeholder="Enter family code"
                    />
                  </b-form-group>
                </b-col>
              </b-row> -->
              <b-row>
                <b-col md="6">
                  <b-form-group
                    label="Contact"
                    invalid-feedback="Contact number is required"
                  >
                    <vue-tel-input
                      v-model="myObj.contact_student"
                      :inputOptions="vueTelOptions"
                      :dropdownOptions="dropOptions"
                      :defaultCountry="$store.state.countryCode"
                    ></vue-tel-input>
                    <!-- @input="CheckContact" -->
                    <small class="mr-1 text-danger" v-if="phoneerror"
                      >Phone number is required.</small
                    >
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="B-Form / CNIC"
                    invalid-feedback="School name is required."
                  >
                    <b-form-input
                      placeholder="Enter B-Form."
                      v-model="myObj.bform_number"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="showCrestMyskoolFields">
                <b-col md="6">
                  <b-form-group label="Learning difficulties">
                    <b-form-radio-group
                      v-model="learningDifficultiesHas"
                      :options="yesNoOptions"
                      name="learning-difficulties"
                    />
                    <b-form-input
                      v-if="learningDifficultiesHas"
                      class="mt-1"
                      v-model.trim="learningDifficultiesDetail"
                      placeholder="Please provide details"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Special medical needs">
                    <b-form-radio-group
                      v-model="specialMedicalNeedsHas"
                      :options="yesNoOptions"
                      name="special-medical-needs"
                    />
                    <b-form-input
                      v-if="specialMedicalNeedsHas"
                      class="mt-1"
                      v-model.trim="specialMedicalNeedsDetail"
                      placeholder="Please provide details"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <!-- <b-col md="12">
                  <b-form-group
                    label="Date of birth in words"
                    invalid-feedback="Date of birth is required."
                  >
                    <b-form-input
                      placeholder="Enter date of birth in words."
                      v-model="myObj.date_of_birth_words"
                      disabled
                    />
                  </b-form-group>
                </b-col> -->
                <b-col md="12">
                  <b-form-group
                    label="Last Institute"
                    invalid-feedback="Institute is required."
                  >
                    <b-form-input
                      placeholder="Enter last institute."
                      v-model="myObj.last_institute"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    label="Current Address"
                    invalid-feedback="Contact number is required"
                  >
                    <b-form-input
                      placeholder="Enter current address"
                      v-model="myObj.address_current"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- <b-row>
                <b-col md="12">
                  <b-form-group
                    label="Permanent Address"
                    invalid-feedback="Contact number is required"
                  >
                    <b-form-input
                      placeholder="Enter permanent address"
                      v-model="myObj.address_permanent"
                    />
                  </b-form-group>
                </b-col>
              </b-row> -->

              <b-row>
                <template v-if="!hideClasses.includes(db)">
                  <b-col md="6">
                    <b-form-group
                      label="Class *"
                      :invalid-feedback="$t('Class is required')"
                      label-class="font-weight-bold"
                      ref="class_admitted"
                    >
                      <v-select
                        v-model="myObj.class_admitted"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="classesOptions"
                        :clearable="false"
                        :reduce="(val) => val.id"
                        label="name"
                        @search:blur="CheckClassAdmit()"
                        :disabled="dataloading"
                        placeholder="Select class admitted."
                        @input="FillSections()"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Section *"
                      invalid-feedback="Section is required"
                      label-class="font-weight-bold"
                      ref="section_admitted"
                    >
                      <v-select
                        v-model="myObj.section_admitted"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="admittedSections"
                        :reduce="(val) => val.id"
                        label="section"
                        :clearable="false"
                        :disabled="dataloading"
                        placeholder="Select section admitted."
                        @input="CheckAdmitSec()"
                      />
                    </b-form-group>
                  </b-col>
                </template>
              </b-row>

              <b-row class="mt-1">
                <b-col md="12">
                  <div class="file-uploader">
                    <h5>
                      <b-spinner
                        variant="dark"
                        label="Spinning"
                        v-if="uploading"
                      ></b-spinner>
                      <span v-else> Upload Documents </span>
                    </h5>
                    <input
                      ref="studentdocs"
                      type="file"
                      class="file_upload"
                      @change="uploadDocument()"
                      multiple="true"
                      accept="image/*,.pdf"
                    />
                  </div>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <div
                    v-for="(file, index) in documents"
                    :key="'student-doc-' + index"
                    class="file"
                  >
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        min-width: 0;
                        flex: 1;
                      "
                    >
                      <a
                        :href="getDocOpenUrl(file)"
                        target="_blank"
                        style="
                          display: flex;
                          align-items: center;
                          min-width: 0;
                          flex: 1;
                        "
                      >
                        <img
                          v-if="isImageDoc(file)"
                          :src="getDocPreviewUrl(file)"
                          class="doc-list-thumb"
                          alt="Document preview"
                          referrerpolicy="no-referrer"
                          @error="onDocPreviewError($event, file)"
                        />
                        <div v-else class="file-type">
                          {{ getDocumentTypeLabel(file) }}
                        </div>
                        <p
                          class="file-name"
                          :title="getDocumentDisplayName(file, index)"
                        >
                          {{ getDocumentDisplayName(file, index) }}
                        </p>
                      </a>
                    </div>
                    <div class="file-delete">
                      <i
                        class="fa fa-trash"
                        aria-hidden="true"
                        @click="deleteDocument(index)"
                      ></i>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card>

            <b-card v-if="db == '/r6Q0RYpjkeTUi0oFvmLqQ=='">
              <h3>Guardian Information</h3>
              <hr />
              <b-row>
                <b-col md="6">
                  <b-form-group
                    label="Name"
                    invalid-feedback="Guardian name is required."
                  >
                    <b-form-input
                      placeholder="Enter guardian name"
                      v-model="myObj.guardian_name"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Relation"
                    invalid-feedback="Relation is required."
                  >
                    <b-form-input
                      placeholder="Enter guardian relation"
                      v-model="myObj.guardian_relationship"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Occupation"
                    invalid-feedback="Occupation is required."
                  >
                    <b-form-input
                      placeholder="Enter occupation"
                      v-model="myObj.guardian_occupation"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="CNIC No"
                    invalid-feedback="CNIC is required."
                  >
                    <b-form-input
                      ref="gCnic"
                      placeholder="Enter CNIC number"
                      v-model="myObj.guardian_cnic"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Contact"
                    invalid-feedback="Please enter correct contact number."
                  >
                    <vue-tel-input
                      v-model="myObj.contact_father"
                      :inputOptions="vueTelOptions"
                      :dropdownOptions="dropOptions"
                      :defaultCountry="$store.state.countryCode"
                    ></vue-tel-input>
                    <!-- @input="CheckFContact()" -->
                    <small class="mr-1 text-danger" v-if="fphoneerror"
                      >Phone number is required.</small
                    >
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Email"
                    invalid-feedback="Email is required."
                  >
                    <b-form-input
                      placeholder="Enter Email"
                      v-model="myObj.guardian_email"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>

            <template v-else>
              <b-card>
                <h3 class="">Father Information</h3>
                <hr />
                <b-row>
                  <b-col md="6">
                    <b-form-group
                      label="Occupation"
                      invalid-feedback="Occupation is required."
                    >
                      <b-form-input
                        v-model="myObj.father_occupation"
                        placeholder="Enter Occupation"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="CNIC No"
                      invalid-feedback="CNIC is required."
                    >
                      <b-form-input
                        ref="fCnic"
                        v-model="myObj.father_cnic"
                        placeholder="Enter CNIC number"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Father's Contact"
                      invalid-feedback="Please enter correct contact number."
                    >
                      <vue-tel-input
                        v-model="myObj.contact_father"
                        :inputOptions="vueTelOptions"
                        :dropdownOptions="dropOptions"
                        :defaultCountry="$store.state.countryCode"
                      ></vue-tel-input>
                      <!-- @input="CheckFContact()" -->
                      <small class="mr-1 text-danger" v-if="fphoneerror"
                        >Phone number is required.</small
                      >
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Email"
                      invalid-feedback="Email is required."
                    >
                      <b-form-input
                        ref="fEmail"
                        v-model="myObj.father_email"
                        placeholder="Enter Email"
                      />
                    </b-form-group>
                    <!-- @focusout="CheckEmail()" -->
                  </b-col>
                  <!-- <b-col md="6">
                    <b-form-group
                      label="Education"
                      invalid-feedback="Education is required."
                    >
                      <b-form-input
                        v-model="myObj.father_education"
                        placeholder="Enter Education"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Employer"
                      invalid-feedback="Employer is required."
                    >
                      <b-form-input
                        v-model="myObj.father_employer"
                        placeholder="Enter Employer"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Monthly income">
                      <b-form-input
                        type="number"
                        v-model="myObj.monthly_income"
                        placeholder="Enter monthly income"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Office Address"
                      invalid-feedback="Address is required."
                    >
                      <b-form-input
                        placeholder="Enter office address"
                        v-model="myObj.office_address"
                      />
                    </b-form-group>
                  </b-col> -->
                </b-row>
              </b-card>
              <b-card>
                <h3 class="">Mother Information</h3>
                <hr />
                <b-row>
                  <b-col md="6">
                    <b-form-group
                      label="Name"
                      invalid-feedback="Name is required"
                    >
                      <b-form-input
                        v-model="myObj.mother_name"
                        placeholder="Enter name"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Occupation"
                      invalid-feedback="Occupation is required."
                    >
                      <b-form-input
                        v-model="myObj.mother_occupation"
                        placeholder="Enter occupation"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="CNIC No"
                      invalid-feedback="CNIC is required."
                    >
                      <b-form-input
                        ref="mCnic"
                        v-model="myObj.mother_cnic"
                        placeholder="Enter CNIC number"
                      />
                      <!-- @focusout="CheckMCnic()" -->
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Mother's Contact"
                      invalid-feedback="Please enter correct phone number."
                    >
                      <vue-tel-input
                        :inputOptions="vueTelOptions"
                        v-model="myObj.contact_mother"
                        :dropdownOptions="dropOptions"
                        :defaultCountry="$store.state.countryCode"
                      ></vue-tel-input>
                      <small class="mr-1 text-danger" v-if="mphoneerror"
                        >Phone number is required.</small
                      >
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Email"
                      invalid-feedback="Email is required."
                    >
                      <b-form-input
                        v-model="myObj.mother_email"
                        placeholder="Enter email address"
                      />
                    </b-form-group>
                  </b-col>
                  <!-- <b-col md="6">
                    <b-form-group
                      label="Education"
                      invalid-feedback="Education is required."
                    >
                      <b-form-input
                        v-model="myObj.mother_education"
                        placeholder="Enter education."
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Employer"
                      invalid-feedback="Employer is required."
                    >
                      <b-form-input
                        v-model="myObj.mother_employer"
                        placeholder="Enter employer"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Office Address"
                      invalid-feedback="Address is required."
                    >
                      <b-form-input
                        v-model="myObj.mother_office_address"
                        placeholder="Enter office address"
                      />
                    </b-form-group>
                  </b-col> -->
                </b-row>
              </b-card>
            </template>

            <template v-if="showCrestMyskoolFields">
              <b-card>
                <h3 class="">Emergency Information</h3>
                <hr />
                <b-row>
                  <b-col md="12">
                    <b-form-group
                      label="Name"
                      invalid-feedback="Name is required"
                    >
                      <b-form-input
                        ref="emerName"
                        placeholder="Enter name"
                        v-model="myObj.emergency_name"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group
                      label="Relation"
                      invalid-feedback="Relation is required."
                    >
                      <b-form-input
                        ref="emerRel"
                        placeholder="Enter relation"
                        v-model="myObj.emergency_relationship"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group
                      label="Emergency contact"
                      invalid-feedback="Please enter correct phone number."
                    >
                      <vue-tel-input
                        v-model="myObj.emergency_contact"
                        :inputOptions="emerOpt"
                        :dropdownOptions="dropOptions"
                        :defaultCountry="$store.state.countryCode"
                        @input="CheckEmerContact"
                      ></vue-tel-input>
                      <small class="mr-1 text-danger" v-if="emerPhoneerror"
                        >Phone number is required.</small
                      >
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </template>

            <b-card v-if="db == '/r6Q0RYpjkeTUi0oFvmLqQ=='">
              <h3 class="">Academic History</h3>
              <hr />
              <template v-for="(history, index) in historyData">
                <h4>{{ history.degree }}</h4>
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Institute">
                      <b-form-input
                        v-model.trim="history.university"
                        placeholder="Enter institute name"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Board">
                      <b-form-input
                        v-model.trim="history.board"
                        placeholder="Enter board name"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Passing Year">
                      <b-form-input
                        type="number"
                        v-model="history.passingYear"
                        placeholder="Enter passing year"
                      />
                    </b-form-group>
                  </b-col>
                  <!-- <b-col md="6">
                    <b-form-group label="Seat Number">
                      <b-form-input
                        v-model.trim="history.seatNo"
                        placeholder="Enter seat number"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Annual / Supply">
                      <v-select
                        v-model="history.examStatus"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="['Annual', 'Supply']"
                        :clearable="false"
                        placeholder="Select annual / supply"
                      />
                    </b-form-group>
                  </b-col> -->
                  <b-col md="6">
                    <b-form-group label="Division / Grade">
                      <b-form-input
                        v-model.trim="history.division"
                        placeholder="Enter division"
                      />
                    </b-form-group>
                  </b-col>
                  <!-- <b-col md="6">
                    <b-form-group label="Discipline">
                      <b-form-input
                        v-model.trim="history.discipline"
                        placeholder="Enter discipline"
                      />
                    </b-form-group>
                  </b-col> -->
                  <!-- <b-col md="6">
                    <b-form-group label="College Affiliated to">
                      <b-form-input
                        v-model.trim="history.affiliatedCollege"
                        placeholder="Enter college affiliated to"
                      />
                    </b-form-group>
                  </b-col> -->
                </b-row>
                <hr v-if="index !== historyData.length - 1" />
              </template>
            </b-card>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col md="7">
            <b-button
              @click="formSubmit()"
              variant="success"
              :disabled="request || uploading"
              block
            >
              <b-spinner v-if="request" type="grow" small label="Loading..." />
              <span v-else>Submit</span>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </template>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters } from "vuex";
import {
  getUploadPath,
  getUploadedPaths,
  uploadToMySkool,
  getDocumentTypeLabel,
  getDocumentDisplayName,
  getMediaPreviewUrl,
  handleDrivePreviewError,
  isImageUrl,
} from "@/utils/gdriveUpload";

import inquiryOther from "../inquiry/inquiryOther.vue";
import inquiryVeritas from "../inquiry/inquiryVeritas.vue";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BButton,
  BMediaAside,
  BImg,
  BMedia,
  BLink,
  BSpinner,
  BBadge,
  BFormFile,
  BFormTextarea,
  BProgress,
  BProgressBar,
  BFormCheckbox,
  BFormRadioGroup,
} from "bootstrap-vue";
export default {
  components: {
    BFormCheckbox,
    BFormRadioGroup,
    BProgress,
    BProgressBar,
    BFormTextarea,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    flatPickr,
    BCard,
    BButton,
    BMediaAside,
    BImg,
    BMedia,
    BLink,
    BSpinner,
    BBadge,
    BFormFile,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    inquiryOther,
    inquiryVeritas,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      request: false,
      file: [],
      mydocs: [],
      moreloading: false,
      plus: "",
      logoloading: false,
      dataloading: false,
      admittedSections: [],
      currentSections: [],
      classes: [],
      genders: ["Male", "Female"],
      categories: [],
      prog: {
        test_fee: false,
        test_passed: false,
        confirmed: false,
      },
      groups: ["A", "B", "O", "AB"],
      religions: ["Islam", "Christianity", "Hinduism", "Buddhists"],
      documents: [],
      uploading: false,
      school: {},
      myObj: {
        id: 0,
        grNo: "",
        family_code: null,
        name: "",
        father_name: "",
        gender: null,
        picture: null,
        date_of_birth: null,
        date_of_birth_words: null,
        date_of_admission: null,
        blood_group: null,
        nationality: null,
        religion: null,
        place_of_birth: null,
        mother_tongue: null,
        address_current: null,
        address_permanent: null,
        contact_student: "",
        contact_father: "",
        contact_mother: "",
        contact_home: null,
        contact_tutor: null,
        last_institute: null,
        last_class: null,
        last_session: null,
        last_result: null,
        last_note: null,
        class_admitted: 0,
        cls_admitted: null,
        class_current: 0,
        cls_current: null,
        section_admitted: 0,
        section_current: 0,
        roll_number: null,
        house: "",
        rfid_number: null,
        bform_number: null,
        date_of_registraion: new Date().toJSON(),
        date_of_readmission: null,
        father_cnic: null,
        father_education: null,
        father_occupation: null,
        monthly_income: null,
        office_phone: null,
        office_address: null,
        father_email: null,
        father_employer: null,
        mother_name: null,
        mother_cnic: null,
        mother_education: null,
        mother_occupation: null,
        mother_office_phone: null,
        mother_office_address: null,
        mother_email: null,
        mother_employer: null,
        guardian_name: null,
        guardian_cnic: null,
        guardian_education: null,
        guardian_occupation: null,
        guardian_office_phone: null,
        guardian_office_address: null,
        guardian_email: null,
        guardian_employer: null,
        guardian_relationship: null,
        emergency_name: null,
        emergency_contact: null,
        emergency_relationship: null,
        learningDifficulties: null,
        specialMedicalNeeds: null,
        physical_handicap: null,
        allergies: null,
        remarks: null,
        monthly_fee: 0,
        discount_percentage: 0,
        challan_due_date: null,
        docs: "",
        status: "registered",
        campusID: 0,
        test_date: null,
      },
      fphoneerror: false,
      mphoneerror: false,
      phoneerror: false,
      emerPhoneerror: false,
      vueTelOptions: { placeholder: "Enter contact number" },
      emerOpt: { placeholder: "Enter emergency contact" },
      yesNoOptions: [
        { text: "No", value: false },
        { text: "Yes", value: true },
      ],
      learningDifficultiesHas: false,
      learningDifficultiesDetail: "",
      specialMedicalNeedsHas: false,
      specialMedicalNeedsDetail: "",
      dropOptions: {
        disabled: false,
        showDialCodeInList: true,
        showFlags: true,
      },
      classesOptions: [],
      check: 1,
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        // disableMobile: true,
      },
      config2: {
        enableTime: true,
        defaultHour: 9,
        altFormat: "j M, Y h:i",
        altInput: true,
        dateFormat: "Y-m-d\\TH:i:S",
      },
      token:
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkZW1vQG15c2tvb2wuYXBwIiwianRpIjoiZmRjZjdhYzQtNmY1OS00Nzg0LTkyNDItZjFjNjRhOTdjODQ0IiwiZXhwIjoxOTkzNzk2MDgwLCJpc3MiOiJteXNrb29sLmFwcCIsImF1ZCI6Im15c2tvb2wuYXBwIn0._pMXprq3AJApizQQlcrVXS3-dPyGFMi0nT9OfLQKBlo",
      db: this.$route.query.db,
      cId: this.$route.query.cId,
      showError: false,
      depList: [],
      depID: 0,
      historyData: [],
      courseList: [],
      hideClasses: ["/r6Q0RYpjkeTUi0oFvmLqQ=="],
      hideWeekendPrograms: true,
      depSettings: null,
      admDeps: [0],
    };
  },
  created() {
    // console.log(this.$route.query.db, this.$route.query.cId);
    if (!this.$route.query.db || !this.$route.query.cId) {
      this.showError = true;
    } else {
      this.db = this.$route.query.db;
      let x = parseInt(this.$route.query.cId);
      if (isNaN(x) || x <= 0) {
        this.showError = true;
      } else {
        this.cId = x;
        // dep for KSA
        if (this.$route.query.db == "/r6Q0RYpjkeTUi0oFvmLqQ==") {
          this.initHistory();
          this.LoadDepartments();
        } else this.LoadClasses();
        this.LoadSchool();
        this.myObj.campusID = this.cId;
      }
    }
  },
  computed: {
    imgUrl() {
      let img = require("@/assets/images/pages/error.svg");
      if (this.$store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        img = require("@/assets/images/pages/error-dark.svg");
        return img;
      }
      return img;
    },
    reportDomain() {
      return (this.$store.state.report || "").replace(/_/g, "");
    },
    showCrestMyskoolFields() {
      if (["myskoolcrestviewacademy", "myskool"].includes(this.reportDomain)) {
        return true;
      }
      const schoolName = String(this.school?.name || "").toLowerCase();
      return schoolName.includes("crest view");
    },
    visibleDepList() {
      if (!this.hideWeekendPrograms || this.db !== "/r6Q0RYpjkeTUi0oFvmLqQ==") {
        return this.depList;
      }
      return this.depList.filter(
        (dep) =>
          !String(dep.name || "")
            .toLowerCase()
            .includes("weekend")
      );
    },
    profilePicturePreview() {
      if (!this.plus) return "";
      if (String(this.plus).startsWith("blob:")) return this.plus;
      return getMediaPreviewUrl(this.plus, "Image");
    },
  },
  methods: {
    ...mapActions({ getDepartment: "getDepartment" }),
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    getDocumentTypeLabel,
    getDocumentDisplayName,

    getDocPreviewUrl(url) {
      return getMediaPreviewUrl(url, "Image");
    },
    getDocOpenUrl(url) {
      return isImageUrl(url) ? getMediaPreviewUrl(url, "Image") : url;
    },
    isImageDoc(url) {
      return isImageUrl(url);
    },
    onDocPreviewError(event, url) {
      if (!url) return;
      handleDrivePreviewError(event, url, "image");
    },
    onPicturePreviewError(event) {
      handleDrivePreviewError(event, this.plus, "image");
    },

    initHistory() {
      this.historyData = [
        {
          id: 0,
          localID: 0,
          role: "student",
          degree: "Matriculation / O Level",
          board: "",
          university: "",
          passingYear: "",
          seatNo: "",
          examStatus: "",
          division: "",
          discipline: "",
          affiliatedCollege: "",
          campusID: this.cId,
        },
        {
          id: 0,
          localID: 0,
          role: "student",
          degree: "Intermediate / A Level",
          board: "",
          university: "",
          passingYear: "",
          seatNo: "",
          examStatus: "",
          division: "",
          discipline: "",
          affiliatedCollege: "",
          campusID: this.cId,
        },
        {
          id: 0,
          localID: 0,
          role: "student",
          degree: "Bachelors",
          board: "",
          university: "",
          passingYear: "",
          seatNo: "",
          examStatus: "",
          division: "",
          discipline: "",
          affiliatedCollege: "",
          campusID: this.cId,
        },
        // {
        //   id: 0,
        //   localID: 0,
        //   role: "student",
        //   degree: "Masters",
        //   board: "",
        //   university: "",
        //   passingYear: "",
        //   seatNo: "",
        //   examStatus: "",
        //   division: "",
        //   discipline: "",
        //   affiliatedCollege: "",
        //   campusID: this.cId,
        // },
      ];
    },

    numberToWords(number) {
      const words = [
        "Zero",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
        "Ten",
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
      ];
      const tens = [
        "",
        "",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ];

      if (number < 20) return words[number];
      if (number < 100)
        return (
          tens[Math.floor(number / 10)] +
          (number % 10 === 0 ? "" : " " + words[number % 10])
        );
      if (number < 1000)
        return (
          this.numberToWords(Math.floor(number / 100)) +
          " Hundred" +
          (number % 100 === 0 ? "" : " and " + this.numberToWords(number % 100))
        );

      // For this specific use case, we assume the year is always in the 2000s
      return (
        "Two Thousand" +
        (number % 1000 !== 0 ? " " + this.numberToWords(number % 1000) : "")
      );
    },
    formatDate(sd, dateStr, ee) {
      console.log(this.myObj.date_of_birth);
      console.log(sd, dateStr, ee);

      if (this.myObj.date_of_birth) {
        const months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        const dayNames = [
          "",
          "First",
          "Second",
          "Third",
          "Fourth",
          "Fifth",
          "Sixth",
          "Seventh",
          "Eighth",
          "Ninth",
          "Tenth",
          "Eleventh",
          "Twelfth",
          "Thirteenth",
          "Fourteenth",
          "Fifteenth",
          "Sixteenth",
          "Seventeenth",
          "Eighteenth",
          "Nineteenth",
          "Twentieth",
          "Twenty First",
          "Twenty Second",
          "Twenty Third",
          "Twenty Fourth",
          "Twenty Fifth",
          "Twenty Sixth",
          "Twenty Seventh",
          "Twenty Eighth",
          "Twenty Ninth",
          "Thirtieth",
          "Thirty First",
        ];

        const [yearStr, monthStr, dayStr] = this.myObj.date_of_birth.split("-");
        const day = parseInt(dayStr, 10);
        const year = parseInt(yearStr, 10);
        const monthIndex = parseInt(monthStr, 10) - 1;

        this.myObj.date_of_birth_words = `${dayNames[day]} ${
          months[monthIndex]
        } ${this.numberToWords(year)}`;
      } else this.myObj.date_of_birth_words = "";
    },

    async uploadDocument(e) {
      let docs = this.$refs.studentdocs.files;
      if (docs.length != 0) {
        this.uploading = true;
        try {
          const uploaded = await uploadToMySkool(docs);
          getUploadedPaths(uploaded).forEach((path) => {
            this.documents.push(path);
          });
          this.myObj.docs = this.documents.join(",");
        } catch (err) {
          console.log(err);
        } finally {
          this.uploading = false;
        }
      }
    },
    deleteDocument(index) {
      // console.log(index);
      this.documents.splice(index, 1);
      this.myObj.docs = this.documents.join(",");
      // console.log(this.myObj.docs);
    },
    async formSubmit() {
      if (
        this.depID > 0 &&
        !this.admDeps.includes(0) &&
        !this.admDeps.includes(this.depID)
      ) {
        let obj = this.depList.find((el) => el.id == this.depID);
        Swal.fire({
          title: "Applications Not Open",
          text:
            "Admissions are not announced for " + (obj?.name || "this Program"),
          icon: "warning",
          timer: 5000,
        });
        return;
      }
      // console.log("check", this.myObj.date_of_registraion);
      this.check = 0; // due to save button click
      const s1 = this.CheckName();
      const s2 = this.CheckFName();
      const s3 = this.CheckGender();
      const s4 = this.CheckDob();
      const s5 = this.CheckCourse();
      const s6 = this.CheckClassAdmit();
      const s7 = this.CheckAdmitSec();
      const s8 = this.CheckPicture();
      const s9 = this.isSameContact();
      // this.CheckGrNo();

      if (
        s1 == false ||
        s2 == false ||
        s3 == false ||
        s4 == false ||
        s5 == false ||
        s6 == false ||
        s7 == false ||
        s8 == false
        // this.phoneerror == true
        // this.CheckGrNo() == false
      ) {
        this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
        this.check = 1;
      } else {
        if (!s9) {
          this.$bvToast.toast(
            this.$t("Please enter the different contact numbers"),
            {
              title: this.$t("Error!"),
              variant: "danger",
              solid: true,
            }
          );
          return;
        }

        this.request = true;
        this.myObj.campusID = this.cId;

        if (this.myObj.date_of_birth == "") {
          this.myObj.date_of_birth = null;
        }
        if (this.myObj.date_of_registraion == "") {
          this.myObj.date_of_registraion = null;
        }
        this.myObj.grNo = this.myObj.grNo.toString();
        if (this.myObj.family_code) {
          this.myObj.family_code = parseInt(this.myObj.family_code);
        } else this.myObj.family_code = 0;

        if (this.hideClasses.includes(this.db)) {
          this.myObj.class_admitted = 0;
          this.myObj.section_admitted = 0;
        }

        this.myObj.class_current = this.myObj.class_admitted;
        this.myObj.section_current = this.myObj.section_admitted;

        let x = parseInt(this.myObj.monthly_income);
        this.myObj.monthly_income = isNaN(x) || x < 0 ? 0 : x;

        this.historyData.forEach((el) => {
          el.passingYear = el.passingYear.toString();
        });

        this.applyCrestMyskoolFieldsBeforeSave();

        let saveObj = {
          student: this.myObj,
          history: this.historyData,
        };
        // students/save
        var status = await this.post({
          url: this.$store.state.domain + "students/SaveNew?db=" + this.db,
          body: saveObj,
          message: "Student added successfully.",
          context: this,
          token: this.token,
          savingStudent: true,
        });
        this.request = false;
        if (status) {
          this.myObj = {
            id: 0,
            grNo: "",
            family_code: null,
            name: "",
            father_name: "",
            gender: null,
            picture: null,
            date_of_birth: null,
            date_of_birth_words: null,
            date_of_admission: null,
            blood_group: null,
            nationality: null,
            religion: null,
            place_of_birth: null,
            mother_tongue: null,
            address_current: null,
            address_permanent: null,
            contact_student: "",
            contact_father: "",
            contact_mother: "",
            contact_home: null,
            contact_tutor: null,
            last_institute: null,
            last_class: null,
            last_session: null,
            last_result: null,
            last_note: null,
            class_admitted: 0,
            cls_admitted: null,
            class_current: 0,
            cls_current: null,
            section_admitted: 0,
            section_current: 0,
            roll_number: null,
            house: "",
            rfid_number: null,
            bform_number: null,
            date_of_registraion: new Date().toJSON(),
            date_of_readmission: null,
            father_cnic: null,
            father_education: null,
            father_occupation: null,
            monthly_income: null,
            office_phone: null,
            office_address: null,
            father_email: null,
            father_employer: null,
            mother_name: null,
            mother_cnic: null,
            mother_education: null,
            mother_occupation: null,
            mother_office_phone: null,
            mother_office_address: null,
            mother_email: null,
            mother_employer: null,
            guardian_name: null,
            guardian_cnic: null,
            guardian_education: null,
            guardian_occupation: null,
            guardian_office_phone: null,
            guardian_office_address: null,
            guardian_email: null,
            guardian_employer: null,
            guardian_relationship: null,
            emergency_name: null,
            emergency_contact: null,
            emergency_relationship: null,
            learningDifficulties: null,
            specialMedicalNeeds: null,
            physical_handicap: null,
            allergies: null,
            remarks: null,
            monthly_fee: 0,
            discount_percentage: 0,
            challan_due_date: null,
            docs: "",
            status: "registered",
            campusID: this.cId,
          };
          this.resetCrestMyskoolFormFields();
          this.documents = [];
          this.admittedSections = [];

          this.cleanStates();
          if (this.$route.query.db == "/r6Q0RYpjkeTUi0oFvmLqQ==") {
            this.initHistory();
            this.classes = [];
            this.classesOptions = [];
            this.depID = 0;
            this.courseList = [];
          }
          this.check = 1;
          Swal.fire({
            title: "Thank you for submitting the form!",
            text:
              this.$route.query.db == "/r6Q0RYpjkeTUi0oFvmLqQ=="
                ? "Now visit admission office to submit documents and pay fees."
                : "We appreciate your interest and will get back to you as soon as possible.",
            icon: "success",
          });
        } else {
          this.$bvToast.toast(this.$t("Something went wrong!"), {
            title: this.$t("Error!"),
            variant: "danger",
            solid: true,
          });
          this.request = false;
          this.check = 1;
        }
      }
    },
    async selectMoreFile() {
      if (this.$refs.mfile.files.length !== 0) {
        this.moreloading = true;
        try {
          const uploaded = await uploadToMySkool(this.$refs.mfile.files);
          uploaded.forEach((el) => {
            this.mydocs.push({
              path: getUploadPath(el),
              orginal: el.originalname || "",
            });
          });
        } catch (error) {
          console.log("error", error);
        } finally {
          this.moreloading = false;
        }
      }
    },
    deleteLogo() {
      if (this.plus && String(this.plus).startsWith("blob:")) {
        URL.revokeObjectURL(this.plus);
      }
      this.myObj.picture = null;
      this.plus = "";
      this.logoloading = false;
      if (this.$refs.fileProfile) {
        this.$refs.fileProfile.value = null;
      }
    },
    async selectlogo() {
      const file = this.$refs.fileProfile.files[0];
      if (!file) return;

      if (this.plus && String(this.plus).startsWith("blob:")) {
        URL.revokeObjectURL(this.plus);
      }

      this.fileProfile = file;
      this.logoloading = true;
      const localPreview = URL.createObjectURL(file);
      this.plus = localPreview;

      try {
        const uploaded = await uploadToMySkool([file]);
        const fn1 = getUploadPath(uploaded[0]);
        URL.revokeObjectURL(localPreview);
        this.plus = fn1;
        this.myObj.picture = fn1;
        this.logoloading = "loaded";
      } catch (err) {
        URL.revokeObjectURL(localPreview);
        this.plus = "";
        this.myObj.picture = null;
        this.logoloading = false;
        console.log(err);
      } finally {
        if (this.$refs.fileProfile) this.$refs.fileProfile.value = "";
      }
    },
    cleanStates() {
      // Efficiently clear state values for all form validation fields
      const fieldsToReset = [
        "name",
        "fname",
        "dob",
        "gender",
        "class_admitted",
        "section_admitted",
        "course",
      ];

      fieldsToReset.forEach((field) => {
        if (this.$refs[field]) {
          this.$refs[field].state = undefined;
        }
      });

      this.deleteLogo(); // reset profile picture
    },
    CheckClassAdmit() {
      if (this.hideClasses.includes(this.db)) {
        return true;
      }
      var elem = this.$refs["class_admitted"];
      if (this.myObj.class_admitted == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckAdmitSec() {
      if (this.hideClasses.includes(this.db)) {
        return true;
      }
      var elem = this.$refs["section_admitted"];
      if (this.myObj.section_admitted == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckName() {
      var elem = this.$refs["name"];
      if (this.myObj.name == "" || this.myObj.name < 3) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckFName() {
      var elem = this.$refs["fname"];
      if (this.myObj.father_name == "" || this.myObj.father_name < 3) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckGender() {
      var elem = this.$refs["gender"];
      if (!this.myObj.gender) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckPicture() {
      if (this.db == "/r6Q0RYpjkeTUi0oFvmLqQ==") {
        let obj = this.depList.find((el) => el.id == this.depID);
        const depName = obj ? obj.name.toLowerCase() : "";
        if (depName.startsWith("diploma")) {
          var elem = this.$refs["picture"];
          if (!this.myObj.picture) {
            return (elem.state = false);
          } else {
            return (elem.state = true);
          }
        } else return true;
      } else return true;
    },
    isSameContact() {
      if (this.db == "/r6Q0RYpjkeTUi0oFvmLqQ==") {
        if (this.myObj.contact_student && this.myObj.contact_father) {
          return this.myObj.contact_student != this.myObj.contact_father;
        }
        return true;
      } else return true;
    },
    CheckDob() {
      var elem = this.$refs["dob"];
      if (this.myObj.date_of_birth == "" || this.myObj.date_of_birth == null) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckCourse() {
      if (this.db == "/r6Q0RYpjkeTUi0oFvmLqQ==") {
        var elem = this.$refs["course"];
        if (!this.myObj.house) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    CheckFContact(s, e) {
      console.log("father", s, e);
      // console.log(this.myObj.contact_father);
      if (this.myObj.contact_father != "") {
        if (e.valid) {
          this.fphoneerror = false;
          this.myObj.contact_father = e.number;
          // console.log(this.myObj.contact_father);
        } else {
          this.fphoneerror = true;
        }
      } else {
        this.fphoneerror = false;
      }
    },
    CheckMContact(s, e) {
      // console.log(this.myObj.contact_mother);
      if (this.myObj.contact_mother != "") {
        if (e.valid) {
          this.mphoneerror = false;
          this.myObj.contact_mother = e.number;
          // console.log(this.myObj.contact_mother);
        } else {
          this.mphoneerror = true;
        }
      } else {
        this.mphoneerror = false;
      }
    },
    CheckContact(s, e) {
      // console.log(this.myObj.contact_student);
      if (this.myObj.contact_student != "") {
        if (e.valid) {
          this.phoneerror = false;
          this.myObj.contact_student = e.number;
          // console.log(this.myObj.contact_student);
        } else {
          this.phoneerror = true;
        }
      } else {
        this.phoneerror = false;
      }
    },
    CheckCnic() {
      var elem = this.$refs["fCnic"];
      if (this.myObj.father_cnic == null || this.myObj.father_cnic == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckMCnic() {
      var elem = this.$refs["mCnic"];
      if (this.myObj.mother_cnic == null || this.myObj.mother_cnic == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckEmail() {
      var elem = this.$refs["fEmail"];
      if (this.myObj.father_email == null || this.myObj.father_email == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckGCnic() {
      var elem = this.$refs["gCnic"];
      if (this.myObj.guardian_cnic == null || this.myObj.guardian_cnic == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckGEmail() {
      var elem = this.$refs["gEmail"];
      if (
        this.myObj.guardian_email == null ||
        this.myObj.guardian_email == ""
      ) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckEmerName() {
      var elem = this.$refs["emerName"];
      if (
        this.myObj.emergency_name == null ||
        this.myObj.emergency_name == ""
      ) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckEmerRelation() {
      var elem = this.$refs["emerRel"];
      if (
        this.myObj.emergency_relationship == null ||
        this.myObj.emergency_relationship == ""
      ) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckEmerContact(s, e) {
      if (this.myObj.emergency_contact != "") {
        if (e && e.valid) {
          this.emerPhoneerror = false;
          this.myObj.emergency_contact = e.number;
        } else {
          this.emerPhoneerror = true;
        }
      } else {
        this.emerPhoneerror = false;
      }
    },
    applyCrestMyskoolFieldsBeforeSave() {
      if (!this.showCrestMyskoolFields) return;
      this.myObj.learningDifficulties = this.learningDifficultiesHas
        ? this.learningDifficultiesDetail || "Yes"
        : "No";
      this.myObj.specialMedicalNeeds = this.specialMedicalNeedsHas
        ? this.specialMedicalNeedsDetail || "Yes"
        : "No";
    },
    resetCrestMyskoolFormFields() {
      this.learningDifficultiesHas = false;
      this.learningDifficultiesDetail = "";
      this.specialMedicalNeedsHas = false;
      this.specialMedicalNeedsDetail = "";
    },
    CheckGrNo() {
      var elem = this.$refs["grNo"];
      if (this.myObj.grNo == null || this.myObj.grNo == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    FillSections(text) {
      //return console.log(this.classes);
      // console.log(this.myObj.class_admitted);

      this.classes.forEach((elem) => {
        if (elem.cls.id === this.myObj.class_admitted) {
          if (elem.sections.length != 0) {
            this.admittedSections = elem.sections;
          } else {
            // console.log("null");
            this.admittedSections = [];
          }
        }
      });
      if (text !== "filled") this.myObj.section_admitted = 0;
      // console.log("Thisis", this.admittedSections);
    },
    setClasses() {
      this.myObj.class_admitted = 0;
      this.myObj.section_admitted = 0;
      this.classes = [];
      this.classesOptions = [];
      if (!this.hideClasses.includes(this.db)) this.LoadClasses();

      this.myObj.house = "";
      this.courseList = [];
      let obj = this.depList.find((el) => el.id == this.depID);

      // show alert if dep is not in admDeps
      // 0 -> open for all
      if (
        this.depID > 0 &&
        !this.admDeps.includes(0) &&
        !this.admDeps.includes(this.depID)
      ) {
        Swal.fire({
          title: "Applications Not Open",
          html:
            "Admissions are not announced for <br>" +
            (obj?.name || "this Program"),
          icon: "warning",
          timer: 5000,
        });
        return;
      }

      if (obj) {
        const depName = obj.name.toLowerCase();
        if (depName.includes("short")) {
          this.courseList = [
            "Fashion Design",
            "Graphic Design",
            "Interior Design",
            "Drawing & Painting",
            "Calligraphy",
            "3D Animation",
            "Photography & Filmmaking",
          ];
        } else if (depName.includes("weekend")) {
          this.courseList = [
            // "3D Design - Blender",
            "Multimedia Design & AI",
            "Resin Art",
            "Creative Advertising",
            "Painting (bootcamp)",
            "Social Media Marketing",
            "Video Editing",
          ];
        } else {
          this.courseList = [
            "Fine Art",
            "Communication Design",
            "Textile Design",
            "Digital Media",
          ];
        }
      }
    },
    async LoadInit() {
      var obj = {
        url:
          this.$store.state.domain +
          "Students/AddInit?campusId=" +
          this.cId +
          "&db=" +
          this.db,
        token: this.token,
      };
      let initData = await this.get(obj);
      // console.log("data:", initData);
      this.myObj.grNo = initData.newG;
      this.myObj.family_code = initData.fCode;
    },
    async LoadDepartments() {
      var obj = {
        url:
          this.$store.state.domain +
          "departments?db=" +
          this.db +
          "&cId=" +
          this.cId,
        token: this.token,
      };
      this.depList = await this.get(obj);

      this.LoadSettings();
    },
    async LoadSettings() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.db +
          "&cID=" +
          this.cId,
        body: ["admission_departments"],
        context: this,
        token: this.token,
        subjects: true,
      });
      this.depSettings = res.find((el) => el.key == "admission_departments");

      if (this.depSettings && this.depSettings.value) {
        // console.log("depSettings:", this.depSettings);
        this.admDeps = this.depSettings.value
          .split(",")
          .filter((el) => el)
          .map(Number);
      } else {
        this.admDeps = [0]; // all by default
      }
      console.log("admDeps:", this.admDeps);
    },
    async LoadClasses() {
      this.dataloading = true;

      var obj = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.db +
          "&cID=" +
          this.cId +
          "&dID=" +
          this.depID,
        token: this.token,
      };
      this.classes = await this.get(obj);
      this.classesOptions = this.classes.map((el) => el.cls);
      this.dataloading = false;
    },
    async LoadSchool() {
      var obj = {
        url:
          this.$store.state.domain +
          "Campuses/GetSelected?id=" +
          this.cId +
          "&db=" +
          this.db,
        token: this.token,
      };
      this.school = await this.get(obj);
      // console.log("sch:", this.school);
    },
  },
};
</script>
<style>
.heading {
  padding: 0;
  margin: 2.171303074670571vw 0;
  /* text-shadow: -4px 0 5px white, 0 4px 5px white, 4px 0 5px white,
      0 -4px 5px white; */
}
.input-form {
  margin: 0 70px;
  background: #fff;
}
#fileInput .custom-file-label {
  color: #707070;
  border: 1px dashed #33312f;
  text-align: center;
  padding: 2.5rem 1.5rem;
  width: 100%;
}
#fileInput input {
  display: none;
}
#imgInput input {
  display: none;
}
#imgInput {
  /* height: 8rem; */
  width: 50%;
}
#imgInput div {
  height: 8vw;
}
#imgInput .custom-file-label {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.type {
  background-color: red;
  border-radius: 10px;
  font-size: 0.8rem;
  padding: 10px;
  color: white;
}
.filename {
  padding-left: 25px;
}
.delete {
  margin: 0 0 0 auto;
  color: red;
}
#checkbox-1 {
  margin-right: 10px !important;
}
.submit {
  background-color: #00c192;
  color: #fff;
  width: 16.5vw;
  height: 4vw;
  font-weight: bold;
  border-color: #00c192;
}
.form-file-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 20px;
}
/* #prop-det, #prop-det div {
    height: 100%;
  } */

.item-group {
  width: 50%;
  /* margin-top: 2.269399707174231vw; */
}
.inputfields,
.inputfields:focus {
  border: 1px solid #33312f;
  border-radius: 0.5856515373352855vw;
  height: 2.562225475841874vw;
  outline: none !important;
  resize: none;
}
textarea.form-control {
  height: 8vw !important;
}
@media only screen and (max-width: 990px) {
  .mob-setting {
    padding: 0 1rem !important;
    width: 100vw !important;
    margin: 0 auto !important;
  }
  .mobile-view {
    margin: 0 !important;
  }
  /* .col-form-label,
  .form-file-text,
  .custom-control-label {
    font-size: 3vw;
  } */
  .item-group {
    margin-top: 0;
  }
  .margin-top-mobile {
    margin-top: 5vw;
  }
  /* .col-form-label {
    display: none;
  } */
  .form-input-mobile-text {
    width: 92vw;
    margin: 10px auto;
    border-radius: 2.8301610541727673vw;
    height: 12.781844802342606vw;
    font-size: 5.171303074670571vw;
    background-color: #f2f2f2 !important;
    border: 1px solid #33312f;
  }
  textarea.form-control {
    height: 12.781844802342606vw !important;
  }
  .form-input-mobile-text:focus {
    background-color: #00c192 !important;
    color: #fff !important;
  }
  .form-input-mobile-text::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: rgb(190, 190, 190);
    opacity: 1; /* Firefox */
    font-family: DINNextRoundedLTW01-Regular;
  }

  .form-input-mobile-text:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: rgb(190, 190, 190);
  }

  .form-input-mobile-text::-ms-input-placeholder {
    /* Microsoft Edge */
    color: rgb(190, 190, 190);
  }

  .form-input-mobile-text:focus::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #fff;
  }
  .form-file-input-mobile {
    border-radius: 2.8301610541727673vw;
    height: 12.781844802342606vw;
    background-color: #f2f2f2 !important;
    color: #fff !important;
  }
  .custom-file-label {
    border-radius: 2.8301610541727673vw !important;
    height: 12.781844802342606vw;
    background-color: #f2f2f2 !important;
    color: #000 !important;
    height: 40vw;
    border: 1px solid #33312f;
  }
  .submit {
    width: 50vw;
    height: 10vw;
  }
  .filename {
    font-size: 3vw;
  }
  .shadowHead {
    font-size: 8vw !important;
  }
  #imgInput div {
    height: 29vw !important;
  }
  .item-group {
    height: 30vw !important;
  }
}

@media only screen and (min-width: 1366px) {
  .submit {
    width: 15.5vw;
    height: 7.8vh;
  }
}
@media only screen and (min-width: 1440px) {
  .submit {
    width: 14.7vw;
    height: 6.7vh;
  }
}
@media only screen and (min-width: 1536px) {
  .submit {
    width: 13.8vw;
    height: 6.9vh;
  }
}
@media only screen and (min-width: 1920px) {
  .submit {
    width: 11vw;
    height: 5.5vh;
  }
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
</style>
<style scoped>
.rcorners2 {
  border-radius: 100px;
  border: 4px solid var(--primary);
  padding: 2px;
}
.sticky {
  position: fixed;
  /* top: 0; */
  right: 2rem;
  /* margin-bottom: 30px; */
  /* position: fixed;
      bottom: 5%;
      z-index: 1031;  */
}
.file-uploader {
  position: relative;
  border: 1px solid #000;
  width: 100%;
  line-height: 30px;
  text-align: center;
  border-radius: 10px;
  font-family: "Helvetica", sans-serif;
  height: 70px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.file_upload {
  opacity: 0;

  /* IE 8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";

  /* IE 5-7 */
  filter: alpha(opacity=0);

  /* Netscape or and older firefox browsers */
  -moz-opacity: 0;

  /* older Safari browsers */
  -khtml-opacity: 0;

  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.file {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}

.file-type {
  background-color: #e62e2d;
  font-family: "Helvetica", sans-serif;
  color: white;
  border-radius: 10px;
  margin-right: 15px;
  height: 50px;
  width: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  overflow: hidden;
  font-size: 0.75rem;
  line-height: 1.1;
}

.file-name {
  font-family: "Helvetica", sans-serif;
  margin: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1;
}

.file-delete i {
  color: #e62e2d;
  font-size: 2rem;
  cursor: pointer;
}
.modal-header {
  display: none;
}
.details-adjust h5 {
  word-wrap: break-word;
}

.student-photo-upload {
  display: flex;
  justify-content: center;
  width: 100%;
}

.student-photo-frame {
  position: relative;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.student-photo-frame--loaded {
  position: relative;
}

.student-photo-img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  cursor: pointer;
  display: block;
}

.student-photo-upload-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.72);
  border-radius: 100px;
  z-index: 3;
}

.student-photo-delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.25rem 0.4rem;
}

.doc-list-thumb {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 6px;
  margin-right: 10px;
  flex-shrink: 0;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
